import React from 'react'
import { Col, Row } from 'antd'
import PropTypes from 'prop-types'
/**
 * InRow component, is using children to render content in a row layout.
 * - cols - this is array of objects for each Col element.
 * - children - the content to be rendered inside the columns. Each child will be placed in its own Col.
 * Example usage:

 <InRow
		gutter={[50, 50]}
		cols={[
			{ md: 8, xs: 24, style: { background: 'blue', padding: 5 } },
			{ md: 16, xs: 24 }
		]}
	>
	<p style={{ background: 'red' }}>1</p>
	<p style={{ background: 'pink' }}>2</p>
</InRow>
 */
const InRow = ({ cols = [], children, ...props }) => {
	const totalChildren = React.Children.count(children)
	return (
		<Row {...props}>
			{React.Children.map(children, (child, index) => {
				const defaultProps = {
					xs: 24,
					md: Math.floor(24 / totalChildren)
				}

				// Apply specific col props if provided
				let specificProps = {}
				if (Array.isArray(cols)) {
					specificProps = cols[index] || {}
				} else if (typeof cols === 'object' && cols !== null) {
					specificProps = cols
				}
				const withProps = { ...defaultProps, ...specificProps }

				return (
					<Col key={child.key || index} {...withProps}>
						{child}
					</Col>
				)
			})}
		</Row>
	)
}
InRow.propTypes = {
	gutter: PropTypes.array,
	cols: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.object),
		PropTypes.object
	]),
	children: PropTypes.node.isRequired
}
export default InRow
